import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { AllInOneUserRepository } from '../infra/AllInOneUserRepository'

export function getAllInOneToken() {
  const storage = new LocalStorageClient()
  const repository = new AllInOneUserRepository({ storage })

  return repository.getLocalToken()
}
